<div class="add-usergroup-dialog">
  <div class="dialog-header">
    <h2>{{ 'users:usergroups_addUsergroup_title' | i18next }}
     <app-basic-button type="ghost" isIcon="true" size="small" (click)="openHelp()" class="info-icon">
        <i class="far fa-info-circle"></i>
     </app-basic-button></h2>
     <app-basic-button type="ghost" isIcon="true" size="medium" (click)="onCancel()" aria-label="Close">
      <i class="far fa-times fs-16"></i>
     </app-basic-button>
  </div>
  <div class="dialog-body">
    <app-basic-textbox [(model)]="usergroupName" [label]="'users:usergroups_UserGroupName' | i18next" [width]="'385px'"
      [size]="'medium'" (modelChange)="onNameChange()">
    </app-basic-textbox>
    <div>
      <app-basic-radio name="option" value="GroupType" [label]="'users:usergroups_GroupType' | i18next" [(model)]="optionType"></app-basic-radio>
      <app-basic-radio name="option" value="BasedOnGroup" [label]="'users:usergroups_BasedOnUserGroup' | i18next" [(model)]="optionType"></app-basic-radio>

      <app-basic-dropdown  [(model)]="selectedGroupType" (modelChange)="onGroupTypeChange()" [items]="groupTypeOptions"
      bindLabel="label" bindValue="value" appendTo="#ddl-panel-wrapper"
      *ngIf="optionType == 'GroupType'" width="385px" [placeholder]="'users:usergroups_SelectGroupType' | i18next">
      </app-basic-dropdown>

      <app-basic-dropdown  [(model)]="selectedBasedOnGroup" (modelChange)="onBasedOnGroupChange()" [items]="userGroupOptions"
      bindLabel="label" bindValue="value" appendTo="#ddl-panel-wrapper"
      *ngIf="optionType == 'BasedOnGroup'" width="385px" [placeholder]="'users:usergroups_SelectUserGroup' | i18next">
      </app-basic-dropdown>
    </div>
  </div>
  <div class="dialog-actions">
    <app-basic-button type="primary" size="small" (click)="onAdd()" [disabled]="!canSave()">
      {{ 'users:usergroups_add' | i18next }}
    </app-basic-button>
  </div>
</div>
